<app-detail-header-template>
  <div top-left>
    <div class="back-btn-container">
      <app-back-button [moveToPreviousUrl]="moveToPreviousUrl" (onBackClick)="toggleTab('auditquery')"></app-back-button>
    </div>
    <h3 class="title-container bold">{{headerText | uppercase}}</h3>
  </div>
  <div top-right [hidden]="!chaseDetailsVisible">
    <app-list [items]="chaseDetails"></app-list>
  </div>
  <div bottom-right [hidden]="chaseDetailsVisible">
    <app-audit-query-grid-filters [stateName]="stateName"></app-audit-query-grid-filters>
  </div>
</app-detail-header-template>

<div class="chase-detail__button-container" *ngIf="showAssignButton">
  <app-button text="Assign" class="chase-button" (onClick)="openAssignModal()"></app-button>
</div>

<app-chase-assignment-modal [(visible)]="isAssignToChaseModalVisible" (onHide)="closeModal()"
  (onUpdate)="updateChaseAssignedData()" [(chases)]="selectedChases" [pageType]="''" [isUnassignEnabled]="false">
</app-chase-assignment-modal>